import { isRecord } from '@/utils/objects';
import type { PageviewNode } from '../types';
import { extractFilters, toNumber, toString } from './parse-helpers';

type PageviewSource = {
  name: string | undefined;
  filtersRaw: unknown;
  inverse: boolean;
  times: number | undefined;
  within: number | undefined;
};

function pageviewNode({ name, filtersRaw, inverse, times, within }: PageviewSource): PageviewNode {
  const parsed = extractFilters(filtersRaw);
  return {
    type: 'pageview',
    url: name !== '*' ? name : undefined,
    inverse,
    times,
    within,
    filters: parsed?.filters,
    filtersOperator: parsed?.operator,
  };
}

/**
 * Parse pageview conditions.
 * Handles: { event: { type: 'page', name, filters }, times, within, inverse }
 *          { type: 'pageview', url, times, within, inverse }
 */
export function parsePageview(raw: Record<string, unknown>): PageviewNode | null {
  const event = isRecord(raw.event) ? raw.event : undefined;
  if (event?.type === 'page' || event?.type === 'pageview') {
    const eventFilter = isRecord(raw.event_filter) ? raw.event_filter : undefined;
    return pageviewNode({
      name: toString(event.name),
      filtersRaw: event.filters,
      inverse: (eventFilter?.inverse ?? raw.inverse) === true,
      times: toNumber(eventFilter?.times ?? raw.times),
      within: toNumber(eventFilter?.within ?? raw.within),
    });
  }

  if (raw.type === 'pageview') {
    return pageviewNode({
      name: toString(raw.url ?? raw.name),
      filtersRaw: raw.filters,
      inverse: raw.inverse === true,
      times: toNumber(raw.times),
      within: toNumber(raw.within),
    });
  }

  return null;
}
